//#region src/sync_menu_section_images_mode.ts
let SyncMenuSectionImagesMode = /* @__PURE__ */ function(SyncMenuSectionImagesMode) {
	SyncMenuSectionImagesMode["DoNotSync"] = "do-not-sync";
	SyncMenuSectionImagesMode["SyncAsHeaderImage"] = "sync-as-header-image";
	SyncMenuSectionImagesMode["SyncAsPageNavImage"] = "sync-as-page-nav-image";
	return SyncMenuSectionImagesMode;
}({});
//#endregion
export { SyncMenuSectionImagesMode };

//# sourceMappingURL=sync_menu_section_images_mode.js.map